export default __webpack_public_path__ + "static/media/ShootAndFit_Icon.14105db6.png";